import React, { useState, useEffect } from 'react';
import {
  Form,
  Button,
  Row,
  Col,
  Spin,
  Modal,
} from 'antd';
import Select from 'components/Select';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import FormSubmitControls from 'components/FormSubmitControls';
import CurrencyInput from 'components/CurrencyInput';
import ModalDelete from 'components/ModalDelete';
import {
  getDetalleSubsidio,
  getDetalleSubsidios,
  postDetalleSubsidio,
  patchDetalleSubsidio,
  deleteDetalleSubsidio,
} from 'api/estructuraOrganizacional/subsidioDetalle';
import { getPermisos } from 'api/usuarios';
import { useDispatch, useSelector } from 'react-redux';
import { selectPermisos } from 'store/catalogos';
import { checkToken } from 'api/utils';
import { FLOAT_NUMER_PATTERN } from 'utils/patterns';
import { getEstadosGlobales, getMeses } from 'api/catalogos';
import { render } from '@testing-library/react';
import { CheckCircleOutlined } from '@ant-design/icons';
import { ESTATUS_ACTIVO, ESTATUS_AUTORIZADO } from 'utils/constants';
import ModalConfirmation from 'components/ModalConfirmation';
import CRUDgeneric from 'utils/CRUDgeneric';

export const rolesPermission = {
  permissionModel: 'detalledesubsidio',
  catalogsModels: [],
};

// eslint-disable-next-line react/prop-types
const SubsidioDetalle = ({ permission, selected, disableEditar }) => {
  const dispatch = useDispatch();
  const permisos = useSelector(selectPermisos);
  const [form] = Form.useForm();
  // const [formDatos] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estadosGlobales, setEstadosGlobales] = useState([]);
  const [meses, setMeses] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);

  const formInstances = [
    form,
    // formDatos,
  ];

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDetalleSubsidios({ subsidio: selected });
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [_data] = await Promise.all([
        getDetalleSubsidios({ subsidio: selected }),
        getPermisos(dispatch, permisos),
      ]);
      const [
        _estadosGlobales,
        _meses,
      ] = await Promise.all([
        getEstadosGlobales(),
        getMeses(),
      ]);
      if (mounted) {
        setData(_data);
        setMeses(_meses);
        setEstadosGlobales(_estadosGlobales);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setVisible(false);
    setVisibleAutorizar(false);
    form.resetFields();
    setSelectedRowKeys([]);
    setSelectedData({});
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const subsidio = await getDetalleSubsidio(match.id);
    setTimeout(() => {
      if (subsidio) {
        form.resetFields();
        // formDatos.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(subsidio));
          // formDatos.setFieldsValue(formatReceived(subsidio));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };
  const onConfirmAutorizar = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar un Carga ya autorizado');
        return;
      }
      const saved = await patchDetalleSubsidio(key, { estados_globales: ESTATUS_AUTORIZADO });
      if (saved) {
        await fetchData();
        onCancel();
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      // await formDatos.validateFields();
      const values = {
        ...form.getFieldsValue(),
        // ...formDatos.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len
      const saved = await (key ? patchDetalleSubsidio(key, { ...values, subsidio: selected }) : postDetalleSubsidio({ ...values, subsidio: selected }));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    if (selectedRowKeys.length) {
      const [key] = selectedRowKeys;
      const deleted = await deleteDetalleSubsidio(key);
      if (deleted) {
        setVisibleAlert(false);
        onCancel();
        await fetchData();
      }
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    valor: [
      requiredRule,
      {
        pattern: FLOAT_NUMER_PATTERN,
        message: 'Ingrese un valor válido',
      },
    ],
  };

  const columns = [
    {
      titleText: 'Mes',
      dataIndex: 'mes',
      key: 'mes',
      width: 200,
      render: (val) => meses.find((e) => e.id === val)?.nombre,
    },
    {
      titleText: 'Límite',
      dataIndex: 'limite_inferior',
      key: 'limite_inferior',
      align: 'Right',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Subsidio',
      dataIndex: 'importe_subsidio',
      key: 'importe_subsidio',
      align: 'Right',
      width: 200,
      render: (val) => currencyFormatter(val || 0),
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estadosGlobales.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit,
            onClickDelete,
          }}
          customActions={[
            {
              onClick: () => setVisibleAutorizar(true),
              permission: { model: 'detalledesubsidio', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              disabled: selectedData?.estados_globales !== ESTATUS_ACTIVO,
              className: 'success',
            },
          ]}
          permission={permission}
          allowExportPDF={false}
          allowAdd={!disableEditar}
          allowDelete={!disableEditar}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Detalle de Subsidio`}
              onFinish={() => form.submit()}
              onCancel={onCancel}
              loading={loading}
              allowSave={!disableEditar}
            />
          )}
          onCancel={onCancel}
          forceRender
          width="40%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={() => onFinish()}
            scrollToFirstError
          >
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="mes"
                label="Mes"
                rules={rules.required}
                hasFeedback
              >
                <Select
                  labelProp="nombre"
                  keyProp="id"
                  dataSource={meses}
                  disabled={disableEditar}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24}>
              <CurrencyInput
                allowClear
                name="limite_inferior"
                rules={rules.valor}
                label="Límite Inferior"
                hasFeedback
                disabled={disableEditar}
              />
            </Col>
            <Col xs={24} sm={24} md={24}>
              <CurrencyInput
                allowClear
                name="importe_subsidio"
                rules={rules.valor}
                label="Subsidio"
                hasFeedback
                disabled={disableEditar}
              />
            </Col>
            <Col xs={24} sm={24} md={24}>
              <Form.Item
                name="estados_globales"
                label="Estatus"
                hasFeedback
              >
                <Select
                  labelProp="descripcion"
                  keyProp="id"
                  dataSource={estadosGlobales}
                  disabled
                />
              </Form.Item>
            </Col>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Detalle de Subsidio${''}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={onConfirmAutorizar}
          ConfirmAutorize
          onCancel={() => setVisibleAutorizar(false)}
          contentTitle={`Autorizar Carga del Reporte del Reloj Checador ${form.getFieldValue('tipo_de_reloj_checador')?.nombre || ''}`}
          open={visibleAutorizar}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default SubsidioDetalle;
